import { DtoExport } from '@core/utils/dto';
import { DispatchMode } from './dispatch-mode';
import { DTO_DEFAULT, DtoType } from '@core/data/dto/dto-types';
import { UpdateDeliveryOrderConfigRequestSchema } from './update-delivery-order-config-request.schema';

export class UpdateDeliveryOrderConfigRequest {
    public pickupPrepTime?: number;
    public latePickupNotificationMins?: number;
    public lateDropoffNotificationMins?: number;
    public pickupNotes?: string;
    public deliverableAction?: string;
    public undeliverableAction?: string;
    public dispatchMode?: DispatchMode;
    public defaultCustomerName?: string;
    public serviceProviders?: string;

    constructor(value?: {
        pickupPrepTime: number;
        latePickupNotificationMins: number;
        lateDropoffNotificationMins: number;
        pickupNotes: string;
        deliverableAction: string;
        undeliverableAction: string;
        dispatchMode: DispatchMode;
        defaultCustomerName: string;
        serviceProviders: string;
    }) {
        if (value) {
            this.pickupPrepTime = value.pickupPrepTime;
            this.latePickupNotificationMins = value.latePickupNotificationMins;
            this.lateDropoffNotificationMins =
                value.lateDropoffNotificationMins;
            this.pickupNotes = value.pickupNotes;
            this.deliverableAction = value.deliverableAction;
            this.undeliverableAction = value.undeliverableAction;
            this.dispatchMode = value.dispatchMode;
            this.defaultCustomerName = value.defaultCustomerName;
            this.serviceProviders = value.serviceProviders;
        }
    }

    @DtoExport([
        {
            type: DTO_DEFAULT,
            dto: UpdateDeliveryOrderConfigRequestSchema,
        },
    ])
    export(type?: DtoType): any {}
}
